import { State } from '../../types';

export const maine: State = {
  name: 'Maine',
  abbreviation: 'ME',
  terms: [
    {
      word: 'Arundel',
      phonetic: 'uh-RUN-d’l',
      // audioUrl: '/audio/arundel.mp3',
      description: 'A town often mispronounced due to its unique ending.'
    },
    {
      word: 'Bangor',
      phonetic: 'BANG-gor',
      // audioUrl: '/audio/bangor.mp3',
      description: 'City in central Maine'
    },
    {
      word: 'Calais',
      phonetic: 'CAL-iss',
      // audioUrl: '/audio/calais.mp3',
      description: 'City in eastern Maine'
    },
    {
      word: 'Damariscotta',
      phonetic: 'dam-uh-riss-COTT-uh',
      // audioUrl: '/audio/damariscotta.mp3',
      description: 'Known for its oyster festival, often mispronounced.'
    },
    {
      word: 'Katahdin',
      phonetic: 'Kuh-TA-din',
      // audioUrl: '/audio/katahdin.mp3',
      description: 'The highest mountain in Maine, name of Native American origin.'
    },
    {
      word: 'Machias',
      phonetic: 'Muh-CHIGH-us',
      // audioUrl: '/audio/machias.mp3',
      description: 'A coastal town with a name often mispronounced.'
    },
    {
      word: 'Monhegan',
      phonetic: 'Mun-HE-gun',
      // audioUrl: '/audio/monhegan.mp3',
      description: 'An island popular with artists, name often mispronounced.'
    },
    {
      word: 'Passamaquoddy',
      phonetic: 'Pass-uh-muh-QUAD-dee',
      // audioUrl: '/audio/passamaquoddy.mp3',
      description: 'A Native American tribe and bay, name often mispronounced.'
    },
    {
      word: 'Saco',
      phonetic: 'SOCK-oh',
      // audioUrl: '/audio/saco.mp3',
      description: 'A city in southern Maine with a commonly mispronounced name.'
    },
    {
      word: 'Schoodic',
      phonetic: 'SKOO-dick',
      // audioUrl: '/audio/schoodic.mp3',
      description: 'A peninsula known for its rugged beauty, name often mispronounced.'
    },
    {
      word: 'Sebago',
      phonetic: 'suh-BAY-go',
      // audioUrl: '/audio/sebago.mp3',
      description: 'A lake and town, name often mispronounced.'
    },
    {
      word: 'Topsham',
      phonetic: 'TOPS-’m',
      // audioUrl: '/audio/topsham.mp3',
      description: 'A town whose name is often mispronounced by visitors.'
    },
    {
      word: 'Wiscasset',
      phonetic: 'wiss-CASS-it',
      // audioUrl: '/audio/wiscasset.mp3',
      description: 'Known as the "prettiest village in Maine," name often mispronounced.'
    },
    {
      word: 'Woolwich',
      phonetic: 'WOOL-itch',
      // audioUrl: '/audio/woolwich.mp3',
      description: 'A town with a name that often confuses non-locals.'
    }
  ]
};